// extracted by mini-css-extract-plugin
export default {"searchDoctors":"DoctorsInBranch_searchDoctors__8hnQq","results":"DoctorsInBranch_results__PuH9x","expend":"DoctorsInBranch_expend__ZXxKX","show":"DoctorsInBranch_show__ce0+h"};